import { createApp } from 'vue'
import App from './App.vue'
import { updateCanonicalUrl } from './canonical'
import { setMetaDescription } from './utils/metaDescription'
import { useAuthStore } from './stores/auth'
import { createPageViewTracker, pageViewTrackingKey } from './analytics/pageViews'
import { createFilmsomniacRouter, installAuthGuards } from './router'
import './assets/site-footer.css'

setMetaDescription()

const router = createFilmsomniacRouter()

const app = createApp(App)
const spaReadyClass = 'filmsomniac-spa-ready'
const spaNavigatingClass = 'filmsomniac-spa-navigating'

const auth = useAuthStore()
auth.initFromStorage()

installAuthGuards(router, auth)

const pageViewTracker = createPageViewTracker({
  auth,
  initialStatus: document.querySelector('meta[name="filmsomniac-response-status"]')?.content || 200,
})
app.provide(pageViewTrackingKey, pageViewTracker.capture)

function markSpaNavigating() {
  document.body.classList.remove(spaReadyClass)
  document.body.classList.add(spaNavigatingClass)
}

function markSpaReady() {
  document.body.classList.remove(spaNavigatingClass)
  document.body.classList.add(spaReadyClass)
}

router.beforeEach((to, from, next) => {
  if (from.name) {
    markSpaNavigating()
  }
  next()
})

router.afterEach((to, from, failure) => {
  if (!failure) {
    updateCanonicalUrl(to)
  }
  pageViewTracker.navigate(to, from, failure)
  if (from.name) {
    requestAnimationFrame(markSpaReady)
  }
})

app.use(router)
router.isReady().then(() => {
  app.mount('#app')
  markSpaReady()
})
